import classifyPageBlockContentFailure, { PageRowFailureKind } from "./classifyPageBlockContentFailure";
import fetchPageBlockContent from "./fetchPageBlockContent";
function mapSettledResult(requestResult) {
    if (requestResult.status === "cancelled") {
        return { kind: "cancelled" };
    }
    if (requestResult.status === "success") {
        const { items, total } = requestResult.response;
        return items.length === 0 ? { kind: "empty" } : { kind: "success", items, total };
    }
    if (classifyPageBlockContentFailure(requestResult) === PageRowFailureKind.EMPTY) {
        return { kind: "empty" };
    }
    return { kind: "error", category: requestResult.category, httpStatus: requestResult.httpStatus };
}
/**
 * Loads one row of block content: a single request plus at most one automatic
 * retry when the failure is transient and the caller's retry budget allows it.
 * The shared signal also aborts the retry request.
 */
export default async function loadPageBlockRowContent({ applicationId, pageKey, blockKey, isNsfw, signal, isAutoRetryAllowed, }) {
    const requestOptions = { applicationId, pageKey, blockKey, isNsfw, signal };
    const firstResult = await fetchPageBlockContent(requestOptions);
    const isAutoRetryableFailure = firstResult.status === "error" && classifyPageBlockContentFailure(firstResult) === PageRowFailureKind.TRANSIENT && isAutoRetryAllowed;
    if (!isAutoRetryableFailure) {
        return { outcome: mapSettledResult(firstResult), didConsumeAutoRetry: false };
    }
    const retryResult = await fetchPageBlockContent(requestOptions);
    return { outcome: mapSettledResult(retryResult), didConsumeAutoRetry: true };
}
